<template>
  <div class="element-input element-textbox element-textbox-splited" :class="{ disabled }">
    <div class="container">
      <div class="label">{{ inputType == "birthday" && !isCarInsure ? "생년월일" : "주민번호" }}</div>

      <div class="body" :class="{split: isCarInsure}">
        <input type="text" v-model="model[0].value" :disabled="disabled" :placeholder="placeholder[0].value" />
      </div>
      <div v-if="isCarInsure" class="body" :class="{split: isCarInsure}">
        <input type="text" v-model="model[1].value" :disabled="!isCarInsure" :placeholder="placeholder[1].value" />
      </div>
      <div class="error" v-if="error">{{ error }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "category", "error", "disabled", "placeholder", "inputType", "isCarInsure" ],
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  methods: {
    selectItem( value ){
      this.$emit( "input", value );
    }
  }

}
</script>
